import { render, staticRenderFns } from "./MobileFeature.vue?vue&type=template&id=551fb92c&"
import script from "./MobileFeature.vue?vue&type=script&lang=js&"
export * from "./MobileFeature.vue?vue&type=script&lang=js&"
import style0 from "./MobileFeature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports